define([
    "underscore",
    "backbone"
], function(_, Backbone) {
    return Backbone.Model.extend({
        idAttribute: 'member_cd',
        url: "/rest_open_account/member",
        urlRoot: "/rest_open_account/member",

        validation: {
            // step0
            how_often_security: {
                required: true,
                pattern: 'number'
            },
            how_often_futures: {
                required: true,
                pattern: 'number'
            },
            how_often_forex: {
                required: true,
                pattern: 'number'
            },
            employment_stat: {
                required: true,
                pattern: 'number'
            },
            annual_income: {
                required: true,
                pattern: 'number'
            },
            value_of_savings: {
                required: true,
                pattern: 'number'
            },
            exp_position_of_derivatives: {
                required: true,
                pattern: 'number'
            },
            exp_seminar_of_derivatives: {
                required: true,
                pattern: 'number'
            },
            exp_qualification_of_derivatives: {
                required: true,
                pattern: 'number'
            },
            occupation: {
                required: true
            },
            industry: {
                required:true
            },
            fund_source: {
                required: true
            },
            fund_source_other: 'validateFundSourceOther',

            // Step 1
            registration_option: {
                required: true
            },
            promotion_cd: {
                required: true,
                pattern:'number'
            },
            company_name: 'validateCompanyName',
            first_name: {
                required: true,
                pattern: 'alphaDashSpacesCommasDots'
            },
            last_name:{
                required: true,
                pattern: 'alphaDashSpacesCommasDots'
            },
            birth: {
                required: true
            },
            address_country_cd: {
                required: true,
                pattern:'number'
            },
            phone_country: {
                required: true,
                pattern: 'number'
            },
            phone_area: {
                required: true,
                pattern: 'number'
            },
            phone_rest: {
                required: true,
                pattern: 'number'
            },
            email: {
                required: true,
                pattern: 'email'
            },
            currency_cd: {
                required: true,
                pattern: 'number'
            },
            gender: {
                required: true
            },
            citizenship_country_cd: {
                required: true,
                pattern: 'number'
            },
            tax_code: {
                required: true,
            },
            mobile_country: {
                required: true,
                pattern: 'number'
            },
            mobile_area: {
                required: true,
                pattern: 'number'
            },
            mobile_rest: {
                required: true,
                pattern: 'number'
            },
            address_province: {
                required: true,
                pattern: 'alphaDashSpacesCommasDots'
            },
            address_city: {
                required: true,
                pattern: 'alphaDashSpacesCommasDots'
            },
            address_rest: {
                required: true,
                pattern: 'alphaDashSpacesCommasDots'
            },
            address_zip: {
                required: true,
                pattern: 'alphaDashSpacesCommasDots'
            },

            // Step 2
            referral_ib: {
                required: false,
                pattern: 'number'
            },
            referred_by: {
                required: false,
                pattern: 'number'
            },
            poa:{
                required: true
            },
            ple:{
                required: true
            },
            signature_step2: 'validateSignature',

            // Step 3
            signature_step3: 'validateSignature',
            consent_step3: {
                acceptance: true
            },

            // Step 4
            signature_step4: 'validateSignature',
            consent_step4: {
                acceptance: true
            }
        },

        labels:{
            address_country_cd: "Country of Address",
            citizenship_country_cd: "Country of Citizenship",
            tax_code: "Tax Code",
            consent_step3: "Customer Agreement",
            consent_step4: "Risk disclosure"
        },

        validateFundSourceOther: function( val, attr, computed) {
            if( this.get('fund_source') == 'other') {
                return Backbone.Validation.validators.required(val, attr, true, this, computed);
            }
        },

		validateCompanyName: function( val, attr, computed) {
			if( this.get('registration_option') == 'corporate') {
                return Backbone.Validation.validators.required(val, attr, true, this, computed);
			}
		},

        validateSignature: function(val, attr, computed){
            // Check if empty
            if("" === val){
                return Backbone.Validation.validators.required(val, attr, true, this, computed);
            }

            // Check equals to fullName is individual or company name if corporate.
            var checkValue = (this.get('registration_option') == 'corporate') ?
                            this.get('company_name') :
                            (this.get('first_name') + " " + this.get('last_name'));

            return Backbone.Validation.validators.equals(val.trim(), attr, checkValue.trim(), this, computed);
        }
    });
});



//////////////////
// WEBPACK FOOTER
// ./assets/uk/main/js/models/member_model.js
// module id = 34
// module chunks = 0